document.addEventListener('DOMContentLoaded', function () {
  const $applications = $('.affiliates__applications')

  if ($applications.length) {
    $('.affiliates__application-reject').click(function (e) {
      const reason = prompt('The reason for denial:', '')
      if (reason === null) return

      const url = $(this).data('url')

      $.ajax({
        url: url,
        data: { reason: reason },
        type: 'POST',
      }).done(function (data) {
        location.reload()
      })
    })
  }
})
